import { render, staticRenderFns } from "./DisputeHeader.vue?vue&type=template&id=00c1849e&"
import script from "./DisputeHeader.vue?vue&type=script&lang=js&"
export * from "./DisputeHeader.vue?vue&type=script&lang=js&"
import style0 from "./DisputeHeader.vue?vue&type=style&index=0&id=00c1849e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports